<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="设备ID">
              <a-input
                placeholder="请输入设备ID"
                v-model="queryParam.serialNo"
                style="width: 100%"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="设备编号">
              <a-input
                placeholder="请输入设备编号"
                v-model="queryParam.deviceId"
                style="width: 100%"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">添加心情灯</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('school_user_info')">-->
      <!--  导出-->
      <!--</a-button>-->
      <!--<a-upload-->
      <!--  name="file"-->
      <!--  :showUploadList="false"-->
      <!--  :multiple="false"-->
      <!--  :headers="tokenHeader"-->
      <!--  :action="importExcelUrl"-->
      <!--  @change="handleImportExcel"-->
      <!--&gt;-->
      <!--  <a-button type="primary" icon="import">导入</a-button>-->
      <!--</a-upload>-->
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">-->
      <!--  <a-menu slot="overlay">-->
      <!--    <a-menu-item key="1" @click="batchDel">-->
      <!--      <a-icon type="delete" />-->
      <!--      删除-->
      <!--    </a-menu-item>-->
      <!--  </a-menu>-->
      <!--  <a-button style="margin-left: 8px">-->
      <!--    批量操作-->
      <!--    <a-icon type="down" />-->
      <!--  </a-button>-->
      <!--</a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a style="color: #fa3a25">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <!--<student-grade-modal ref="modalForm" @ok="modalFormOk"></student-grade-modal>-->
    <MoodLightModal ref="modalForm" @refreshData="loadData" />
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import MoodLightModal from './modules/MoodLightModal'
import { postAction } from '@/api/manage'

export default {
  name: 'MoodLightManage',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    MoodLightModal,
  },
  data() {
    return {
      description: '心情灯管理页面',
      // 表头
      columns: [
        {
          title: '设备ID',
          dataIndex: 'serialNo',
          width: 60,
          align: 'center',
        },
        {
          title: '设备编号',
          align: 'center',
          dataIndex: 'deviceId',
        },
        {
          title: '所属类型',
          align: 'center',
          customRender: (_, record) => {
            return record?.studentName || record?.className || record?.gradeName || '全校'
          },
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '心情灯状态',
          align: 'center',
          dataIndex: 'moodLamp',
          customRender: (_, record) => {
            return record.moodLamp || <a-tag>暂无数据</a-tag>
          },
        },
        {
          title: '设备状态',
          align: 'center',
          dataIndex: 'status',
          customRender: (_, record) => {
            return record.status == 1 ? (
              <a-tag color="green">在线</a-tag>
            ) : (
              <a-tag color="red">离线</a-tag>
            )
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/moodLamp/queryPageList',
        delete: '/moodLamp/deleteMoodLamp',
        deleteBatch: '',
        exportXlsUrl: '',
        importExcelUrl: '',
      },
      dictOptions: {},
    }
  },
  created() {},
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
